
import {Component, Prop, Vue} from 'vue-property-decorator';
import {SportType} from "@/modules/federation/services/SportTypeService";

@Component
    export default class SportTypeBadge extends Vue {
        @Prop() public value!: SportType;
    }
